import {
  DASHBOARD_PATH,
  CREATE_MERCHANT,
  IN_UNDERWRITING_PATH,
  PENDING_PATH,
  COMPLETE_PATH,
  USERS_LIST_PATH,
  TEAMS_LISTS_PATH,
  PROFILE_PATH,
  LEADS_PATH,
  LEADS_CREATE_PATH,
  CALENDAR_SCHEDULE_PATH,
  SALES_DBA_LISTING,
  ROLE_PERMISSION,
  ISSUE_LIST_PAGE,
  USER_PERMISSION,
  MERCHANT_ACCOUNTS_LIST,
  CONTRACTS_LIST_PATH,
} from './path';

import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import ContactsIcon from '@mui/icons-material/Contacts';
import PostAddIcon from '@mui/icons-material/PostAdd';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export const sidebarItems = [
  { path: DASHBOARD_PATH, label: 'Dashboard', icon: <DashboardOutlinedIcon sx={{ fontSize: 16 }} />, permission: null },
  { path: CREATE_MERCHANT, label: 'Create Merchant', icon: <AddCircleOutlineIcon sx={{ fontSize: 16 }} />, permission: 'dba-create' },
  // new route
  { path: MERCHANT_ACCOUNTS_LIST, label: 'Merchatn Accounts', icon: <DescriptionOutlinedIcon sx={{ fontSize: 16 }} />, permission: 'dba-list' },
  
  
  { path: IN_UNDERWRITING_PATH, label: 'In Underwriting', icon: <DescriptionOutlinedIcon sx={{ fontSize: 16 }} />, permission: 'dba-list' },
  { path: PENDING_PATH, label: 'Pending', icon: <PendingActionsIcon sx={{ fontSize: 16 }} />, permission: 'dba-list' },
  { path: COMPLETE_PATH, label: 'Completed', icon: <TaskAltIcon sx={{ fontSize: 16 }} />, permission: 'dba-list' },
  { path: SALES_DBA_LISTING, label: 'Sales Dba Listing', icon: <DescriptionOutlinedIcon sx={{ fontSize: 16 }} />, permission: 'dba-sales-list' },
  { path: USERS_LIST_PATH, label: 'Users', icon: <PeopleOutlineIcon sx={{ fontSize: 16 }} />, permission: 'user-list' },
  { path: TEAMS_LISTS_PATH, label: 'Team Leads', icon: <SupervisorAccountIcon sx={{ fontSize: 16 }} />, permission: 'team-list' },
  { path: PROFILE_PATH, label: 'Profile', icon: <PersonOutlineIcon sx={{ fontSize: 16 }} />, permission: null },
  { path: LEADS_PATH, label: 'Leads', icon: <ContactsIcon sx={{ fontSize: 16 }} />, permission: 'lead-list' },
  { path: LEADS_CREATE_PATH, label: 'Leads Create', icon: <PostAddIcon sx={{ fontSize: 16 }} />, permission: 'lead-create' },
  { path: ISSUE_LIST_PAGE, label: 'Issue Lists', icon: <CalendarMonthIcon sx={{ fontSize: 16 }} />, permission: 'issue-list' },
  { path: CONTRACTS_LIST_PATH, label: 'E Signature Contracts', icon: <DescriptionOutlinedIcon sx={{ fontSize: 16 }} />, permission: null },
  { path: ROLE_PERMISSION, label: 'Role Permission', icon: <PostAddIcon sx={{ fontSize: 16 }} />, permission: 'role-view' },
  { path: CALENDAR_SCHEDULE_PATH, label: 'Calendar Schedule', icon: <CalendarMonthIcon sx={{ fontSize: 16 }} />, permission: null },
  { path: USER_PERMISSION, label: 'User Permissions', icon: <CalendarMonthIcon sx={{ fontSize: 16 }} />, permission: 'user-direct-permission' },
];

export const getFilteredSidebarItems = (userPermissions = []) => {
  return sidebarItems.filter(
    (item) => item.permission === null || userPermissions.includes(item.permission)
  );
};
